import { memo } from "react"

import { BackButton } from "../../components/Buttons/BackButton"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProjectFormSubmissionDetailViewTopBar = memo(() => {
	return <BaseTopBar leftContent={<BackButton />} />
})
ProjectFormSubmissionDetailViewTopBar.displayName = "ProjectFormSubmissionDetailViewTopBar"
